export default __webpack_public_path__ + "static/media/bullet.e1abfb76.svg";